import { __awaiter } from "tslib";
import { TeleInterconsultService } from "@/servicesTs/models/teleopi/teleInterconsult";
const moduleTableTICWaitingList = {
    namespaced: true,
    state: {
        teleInterconsults: [],
        dataFilter: {
            step: "",
            node_id: 0,
            state: "",
            isAps: true,
        },
        showLoader: false,
    },
    getters: {
        getShowLoader(state) {
            return state.showLoader;
        },
        getTICWaitingList(state) {
            return state.teleInterconsults;
        },
    },
    mutations: {
        setLoader(state, payLoad) {
            state.showLoader = payLoad;
        },
        setDatafilter(state, payLoad) {
            state.dataFilter = payLoad;
        },
        setTICWaitingList(state, teleInterconsults) {
            state.teleInterconsults = teleInterconsults;
        },
    },
    actions: {
        getTICWaitingList({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoader", true);
                let response = [];
                if (state.dataFilter.isAps) {
                    response = yield TeleInterconsultService.getTicByStateStepAndOriginNode(state.dataFilter.step, state.dataFilter.node_id, state.dataFilter.state);
                }
                else {
                    response = yield TeleInterconsultService.getTicByStateStepAndDestinationNode(state.dataFilter.step, state.dataFilter.node_id, state.dataFilter.state);
                }
                commit("setTICWaitingList", response);
                commit("setLoader", false);
            });
        },
    },
};
export default moduleTableTICWaitingList;
